import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import {popConfetti, gtmPush, cookie} from 'helpers';

import {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutReturnButton,
    resetCheckoutCustomer,
    resetCheckoutOpportunity,
} from 'store';

class Success extends Component {
    componentDidMount() {
        this.props.setCheckoutTitle('Takk, din påmelding er bekreftet!');
        this.props.setCheckoutSubtitle('');
        this.props.setCheckoutReturnButton(false);

        this.props.resetCheckoutCustomer();
        this.props.resetCheckoutOpportunity();

        this._onPurchaseTracking();

        popConfetti({
            color: '#fff',
            selector: '#successful'
        });
        this._removeCookies();
    }

    _removeCookies(){
        let cookies = [];
        cookie.set('shoppingCart', JSON.stringify(cookies), 0);
        cookie.set('shoppingCartUserData', JSON.stringify(cookies), 0);
        cookie.set('shoppingCartTimeScheduleAutumn', '', 0);
        cookie.set('shoppingCartTimeScheduleSpring', '', 0);
        cookie.set('shoppingCartStep', 0, 0);
    }

    _onPurchaseTracking() {
        const { id, amount, courses, programs } = this.props.opportunity;

        gtmPush({
            'event': 'purchase',
            'ecommerce': {
                'purchase': {
                    'actionField': {
                        'id': id,
                        'affiliation': 'bjorknesprivatskole',
                        'revenue': amount,
                        'tax': 0,
                        'shipping': 0,
                        'coupon': ''
                    },
                    'products': [...courses, ...programs].map(product => ({
                        'name': product.name,
                        'id': product.id,
                        'price': product.price,
                        'brand': 'bjorknesprivatskole',
                        'category': product.academicArea || product.category || '',
                        'variant': product.semester,
                        'quantity': 1
                    }))
                }
            }
        });
    }

    render() {
        return (
            <div id="successful"></div>
        );
    }
}

const mapStateToProps = state => ({
    opportunity: state.opportunity,
});

const actions = {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutReturnButton,
    resetCheckoutCustomer,
    resetCheckoutOpportunity,
}

export default connect(mapStateToProps, actions)(Success);


// WEBPACK FOOTER //
// ./src/partials/Checkout/Success.js